type TransactionEvent = {
  day: Date | string;
  count: number;
};

type Transactions = {
  [key: string]: TransactionEvent[];
};

type MarketplaceTransactionEvents = {
  [key: string]: {
    VISA: TransactionEvent[];
    MASTERCARD: TransactionEvent[];
    AMEX: TransactionEvent[];
  };
};

type CNTransactions = {
  authsThatFailedToClearByMarketplace: MarketplaceTransactionEvents;
  dailyFulfillmentsByMarketplace: MarketplaceTransactionEvents;
};

type ChartLegend = {
  type?: string[] | string;
  title: string;
  color: string;
};

const CHART_LEGEND: ChartLegend[] = [
  { type: ['VISA'], title: 'Visa', color: '#043381' },
  { type: ['MASTERCARD'], title: 'Mastercard', color: '#eb001b' },
  { type: ['AMEX'], title: 'Amex', color: '#0071d6' },
];

export {
  CNTransactions,
  TransactionEvent,
  Transactions,
  CHART_LEGEND,
  ChartLegend,
};
